import { X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export function Modal({
  open, onClose, title, children, size = "md",
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  size?: "sm" | "md" | "lg" | "xl";
}) {
  const width = { sm: "max-w-md", md: "max-w-lg", lg: "max-w-2xl", xl: "max-w-4xl" }[size];
  return (
    <AnimatePresence>
      {open && (
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <motion.div
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="fixed inset-0 bg-surface-900/60 backdrop-blur-sm"
            onClick={onClose}
          />
          <div className="flex items-center justify-center min-h-full p-4">
            <motion.div
              initial={{ opacity: 0, y: 12, scale: 0.98 }}
              animate={{ opacity: 1, y: 0,  scale: 1    }}
              exit={{    opacity: 0, y: 8,  scale: 0.98 }}
              transition={{ duration: 0.2 }}
              className={`relative z-10 w-full ${width} bg-white rounded-2xl shadow-elevate-3`}
            >
              <div className="flex items-center justify-between px-6 py-4 border-b border-surface-200">
                <h2 className="text-lg font-semibold text-surface-900">{title}</h2>
                <button onClick={onClose} className="p-1.5 hover:bg-surface-100 rounded-md">
                  <X className="h-5 w-5 text-surface-500" />
                </button>
              </div>
              <div className="p-6">{children}</div>
            </motion.div>
          </div>
        </div>
      )}
    </AnimatePresence>
  );
}
